import { BaseModel } from './base-model';
export class Review extends BaseModel {
  name: string;
  comment: string;
  stayStartDate: Date;
  stayEndDate: Date;
  evaluation: number;
  answer: string;
}
